import React from 'react'
import { graphql } from 'gatsby'
import CssEscape from 'css.escape'

import MicrocmsImage from '@atoms/MicrocmsImage'
import Layout from '@src/components/Layout'
import ListBox from '@src/components/ListBox'
import CategoryChildHero from '@src/components/CategoryChildHero'
import { Article } from '@models/Article'
import { Parent, convertPlainTitle } from '@models/Parent'
import { useTranslation } from '@models/Translation'

import * as style from './style.module.sass'

type FeatureChildTemplateProps = {
  data: {
    parent: Parent
    englishParent: Parent
    allArticle: {
      nodes: Article[]
    }
    allEnglishArticle: {
      nodes: Article[]
    }
  }
}

const FeatureChildTemplate: React.FC<FeatureChildTemplateProps> = ({
  data,
}) => {
  const { locale } = useTranslation()
  const articles =
    locale === 'en' ? data.allEnglishArticle.nodes : data.allArticle.nodes
  const parent = locale === 'en' ? data.englishParent : data.parent

  // 英語のページのみ存在しないのでHEADでリダイレクトする
  if (locale === 'en' && parent === null) {
    return <></>
  }

  return (
    <Layout>
      <div className={style.wrapper}>
        <CategoryChildHero title="FEATURES" />

        <section className={style.topic}>
          <div className={style.image}>
            <div
              className={style.background}
              style={{
                backgroundImage: `url(${CssEscape(
                  parent.image.url,
                )}?fm=webp&w=120)`,
              }}
            />
            <MicrocmsImage
              image={parent.image}
              alt={convertPlainTitle(parent.title, locale)}
              type="hero"
              disableLazyLoad
            />
          </div>
          <div className={style.body}>
            <h2
              className={style.title}
              dangerouslySetInnerHTML={{ __html: parent.title }}
            />
            <div
              className={style.text}
              dangerouslySetInnerHTML={{ __html: parent.contents }}
            />
          </div>
        </section>

        <ListBox
          articles={articles}
          subLine="エピソード一覧"
          headline="All Episodes"
          gtmClickType="feature-child"
        />
      </div>
    </Layout>
  )
}

export { Head } from '../ChildTemplateHead'

export default FeatureChildTemplate

export const query = graphql`
  query ($pageId: String!) {
    parent(pageId: { eq: $pageId }) {
      pageId
      path
      title
      category
      image {
        height
        url
        width
      }
      contents
      writer
      projectName
    }
    englishParent(pageId: { eq: $pageId }) {
      pageId
      path
      title
      category
      image {
        height
        url
        width
      }
      contents
      writer
      projectName
    }
    allArticle(
      filter: { parentPage: { id: { eq: $pageId } } }
      sort: { rawPublishDate: DESC }
    ) {
      nodes {
        blogId
        path
        title
        thumbnail {
          url
          width
          height
        }
        publishDate
        parentPage {
          id
        }
        data {
          category
          requester
        }
        enableVoice
        isMembersOnly
      }
    }
    allEnglishArticle(
      filter: { parentPage: { id: { eq: $pageId } } }
      sort: { rawPublishDate: DESC }
    ) {
      nodes {
        blogId
        path
        title
        thumbnail {
          url
          width
          height
        }
        publishDate
        parentPage {
          id
        }
        data {
          category
          requester
        }
        enableVoice
        isMembersOnly
      }
    }
  }
`
